<template>
  <div
    class="screen-loading"
    :class="{ 'no-mask': loading }"
    :style="{ height, width, left, top }"
    v-if="show"
  >
    <div>
      <svg width="50px" height="50px">
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="transparent"
          stroke-width="3"
          stroke-dasharray="31.415, 31.415"
          stroke="#02bcfe"
          stroke-linecap="round"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0, 25 25;360, 25 25"
            dur="1.5s"
            repeatCount="indefinite"
          ></animateTransform>
          <animate
            attributeName="stroke"
            values="#02bcfe;#3be6cb;#02bcfe"
            dur="3s"
            repeatCount="indefinite"
          ></animate>
        </circle>
        <circle
          cx="25"
          cy="25"
          r="10"
          fill="transparent"
          stroke-width="3"
          stroke-dasharray="15.7, 15.7"
          stroke="#3be6cb"
          stroke-linecap="round"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="360, 25 25;0, 25 25"
            dur="1.5s"
            repeatCount="indefinite"
          ></animateTransform>
          <animate
            attributeName="stroke"
            values="#3be6cb;#02bcfe;#3be6cb"
            dur="3s"
            repeatCount="indefinite"
          ></animate>
        </circle>
      </svg>
      <span>{{ $l("加载中...") }} </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "screenLoading",
  props: {
    loading: false,
  },
  data() {
    return {
      show: false,
      height: 0,
      width: 0,
      left: 0,
      top: 0,
    };
  },
  watch: {
    loading: {
      handler: function () {
        if (this.loading) {
          this.show = true;
          this.height = "100%";
          this.width = "100%";
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.screen-loading {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
  div {
    width: vw(100);
    height: vw(100);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    span {
      font-size: 1rem;
      font-family: AlibabaPuHuiTi;
      font-weight: 400;
      color: #cedce6;
    }
  }
}
.no-mask {
  background-color: transparent;
}
</style>